import React from 'react'

const componentPromise = import('./home' /* webpackChunkName: "homePage"*/)

const Component = React.lazy(() => componentPromise)

export default Component